export default __webpack_public_path__ + "static/media/arrowDown.51dbc76e.svg";